import "./styles/main.scss"

import * as React from "react";
import * as ReactDOM from "react-dom";

import PageComponent from "./PageComponent";
import { FetchSettings } from "@loschmidt/commons/fetch";

// This project uses codegen api.
// Custom function createUrl adds URL prefix.
// So FetchSettings.urlPrefix must be an empty string.
FetchSettings.urlPrefix = '';

ReactDOM.render(
  <PageComponent />,
  document.getElementById("react-root")
);
